import { useRef, useState } from "react";
import CustomButton from "../../../../components/CustomButton";
import DatePicker from "../../../../components/misc/DatePicker";
import useTableCtx from "../../../../components/tables/tableContext/useTableCtx";
import { fetchTransportHistoryReport } from "../../../../redux/api/transport.api";
import { useAppDispatch } from "../../../../redux/hooks";
import Text from "../../../../styleguide/Text";
import { dateToString, parseDate } from "../../../../utils/dateAndTime";
import {
  getTransportHistoryFilters,
  TRANSPORT_HISTORY_DATE_FORMAT,
} from "../transportHistoryFilters";

function TransportHistoryHeader() {
  const dispatch = useAppDispatch();
  const { tableSearch, handleTableSearch } = useTableCtx()!;
  const [isExporting, setIsExporting] = useState(false);
  const exportInProgress = useRef(false);
  const startFrom = parseDate(
    tableSearch?.data_start_de_la,
    TRANSPORT_HISTORY_DATE_FORMAT,
  );
  const startUntil = parseDate(
    tableSearch?.data_start_pana_la,
    TRANSPORT_HISTORY_DATE_FORMAT,
  );
  const invalidRange = Boolean(
    startFrom && startUntil && startFrom > startUntil,
  );

  const handleExport = async () => {
    if (invalidRange || exportInProgress.current) return;
    exportInProgress.current = true;
    setIsExporting(true);
    try {
      await dispatch(
        fetchTransportHistoryReport(getTransportHistoryFilters(tableSearch)),
      );
    } finally {
      exportInProgress.current = false;
      setIsExporting(false);
    }
  };

  return (
    <div className="mb-4 grid grid-cols-[minmax(0,1fr)_auto] items-center gap-x-6 gap-y-4 lg:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)]">
      <Text
        variant="h3"
        component="h3"
        className="col-start-1 row-start-1 min-w-0 !mb-0 font-semibold text-slate-900">
        Istoric transporturi
      </Text>
      <div className="col-span-2 row-start-2 flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:items-end sm:justify-self-center lg:col-span-1 lg:col-start-2 lg:row-start-1">
        <DatePicker
          label="Data start de la"
          placeholder="zz/ll/aaaa"
          dateFormat="DD/MM/YYYY"
          className="sm:!w-[200px]"
          textInputClassName="!mb-0"
          gutterBottom={false}
          value={startFrom}
          maxDate={startUntil ?? undefined}
          withClearData
          handleChangeDate={(date) =>
            handleTableSearch("data_start_de_la", dateToString(date))
          }
        />
        <DatePicker
          label="Data start pana la"
          placeholder="zz/ll/aaaa"
          dateFormat="DD/MM/YYYY"
          className="sm:!w-[200px]"
          textInputClassName="!mb-0"
          gutterBottom={false}
          value={startUntil}
          minDate={startFrom ?? undefined}
          withClearData
          handleChangeDate={(date) =>
            handleTableSearch("data_start_pana_la", dateToString(date))
          }
        />
      </div>
      <div className="col-start-2 row-start-1 justify-self-end lg:col-start-3">
        <CustomButton
          variant="action"
          icon="DOWNLOAD"
          tooltipTitle={
            invalidRange
              ? "Data start pana la nu poate fi anterioara datei start de la."
              : "Descarca istoricul transporturilor in format PDF pentru filtrele selectate."
          }
          loading={isExporting}
          disabled={isExporting || invalidRange}
          onClick={handleExport}>
          Genereaza raport
        </CustomButton>
      </div>
    </div>
  );
}

export default TransportHistoryHeader;
